import { LpsInfos } from '@/core/types/dmp-connect'
import { t } from '@lingui/macro'

export const defaultLpsInfos: Omit<LpsInfos, 's_instance'> = {
  s_idam: 'W4084252D591', // numéro de conformité INSi CNDA de PROMOTAL MEDCONNECT (attestation du 09/09/2025)
  s_numAM: '04', // valeur fixe confirmée par Icanopée
  s_name: 'PROMOTAL MEDCONNECT:1', // homologation avec suffix :${version}
  s_version: '1',
}

export const interopCodeIds = [
  'healthcareSettings', // cadre de soin.
  'practiceSettings', // cadres d’exercice.
  'activitySectors', // secteurs d’activité.
  'docFormats', // formats de documents.
  'docTypes', // types de documents.
  'professions', // professions.
  'physicianSpecialities', // spécialités de médecins.
  'pharmacistSpecialities', // spécialités de pharmaciens.
  'dentistSpecialities', // spécialité de chirurgiens dentistes.
  'docCategories', // catégories des documents.
  'docTypesToDocCategories', // association des types de documents aux catégories de documents.
  'docTypesHistory', // types de documents (y compris les types obsolètes).
  'docTypesTranslation', // association des codes de type de documents vers leurs valeurs les plus à jour.
  'functionCodes', // codes des fonctions/rôles.
  'activityTypes', // codes des types d’activité.
] as const

export type InteropCodeId = typeof interopCodeIds[number]

export const structureIdTypes = {
  ADELI: {
    value: 'ADELI',
    label: 'Identifiant cabinet ADELI',
    firstDigit: 0,
    length: 9,
    type: 'w', // alphanum
  },

  FINESS: {
    value: 'FINESS',
    label: 'FINESS',
    firstDigit: 1,
    length: 9,
    type: 'w', // alphanum
  },

  SIREN: {
    value: 'SIREN',
    label: 'SIREN',
    firstDigit: 2,
    length: 9,
    type: 'w', // alphanum
  },

  SIRET: {
    value: 'SIRET',
    label: 'SIRET',
    firstDigit: 3,
    length: 14,
    type: 'w', // alphanum
  },

  RPPS: {
    value: 'RPPS',
    label: 'Identifiant cabinet RPPS',
    firstDigit: 4,
    length: 14,
    type: 'd', // digits
  },
}

export const SESSION_VERIFICATION_INTERVAL = 30000

export function getDmpErrorMessage(apiErrorType: string) {
  switch (apiErrorType) {
    case '1':
      return t`Check if the patient information is correct.`
    case '2':
      return t`An error occurred during the interaction with the Shared Medical Record (DMP).`
    case '3':
      return t`Unable to establish a network connection. Please check your internet connection.`
    case '4':
      return t`Card reading error: An issue occurred while attempting to read the health card.`
    case '6':
      return t`TLSi transaction failed. Please try again or contact support.`
    case '7':
      return t`An issue occurred during the DP transaction. Please verify the information.`
    case '5000':
      return t`An error occurred in communication with the WebSocket server.`
    case '6000':
      return t`An error occurred in the JavaScript management module. Contact support if the issue persists.`
    default:
      return t`Unknown error, please contact support.`
  }
}

export function getInsIdentityResultMessage(insIdentityResult: number) {
  switch (insIdentityResult) {
    default:
    case 1:
      return t`No identity found`
    case 2:
      return t`A unique identity found`
    case 3:
      return t`Multiple identities found`
  }
}

export const INS_OID = {
  'INS-A': '1.2.250.1.213.1.4.1',
  'INS-C_prod': '1.2.250.1.213.1.4.2',
  'INS-C_test': '1.2.250.1.213.1.4.6',
  'INS-C_demo': '1.2.250.1.213.1.4.7',
  'INS-NIR_prod': '1.2.250.1.213.1.4.8',
  'INS-NIA': '1.2.250.1.213.1.4.9', // provisoire
  'INS-NIR_test': '1.2.250.1.213.1.4.10 ',
  'INS-NIR_demo': '1.2.250.1.213.1.4.11',
}
